import dayjs, { Dayjs } from 'dayjs';
import { useState, useEffect } from 'react';
import { SubscriptionState } from '../App/useSubscription';

const initialSummary: Summary = {
  totalPrice: 0,
  totalOriginalPrice: 0,
  deliveryPrice: 0,
};

/**
 * 現在の合計金額などを担う
 */
export const useSummary = (
  subscription: SubscriptionState
) => {
  const [summary, setSummary] = useState<Summary>(initialSummary);

  useEffect(() => {
    if (!subscription) return;

    const totalPrice =
      subscription.deliveryPriceAmount +
      subscription.subscriptionLines.reduce(
        (sum, subscriptionLine) => sum + subscriptionLine.currentPriceAmount * subscriptionLine.quantity,
        0
      );
    const totalOriginalPrice =
      subscription.deliveryPriceAmount +
      subscription.subscriptionLines.reduce(
        (sum, subscriptionLine) => sum + subscriptionLine.lineDiscountedPriceAmount * subscriptionLine.quantity,
        0
      );
    const deliveryPrice = subscription.deliveryPriceAmount;

    setSummary({
      ...summary,
      totalPrice,
      totalOriginalPrice,
      deliveryPrice,
    });

  }, [subscription]);

  return summary;
}; 

// types

export type Summary = {
  totalPrice: number;
  totalOriginalPrice: number;
  deliveryPrice: number;
};
